export default {
  stats: {
    orders: 'Ordini',
    sales: 'Fatturato',
  },
};
